var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCcs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7015 13.5907C49.1599 13.5907 54.4093 18.8401 54.4093 25.2985V33.9309C54.4093 40.3892 49.1599 45.6386 42.7015 45.6386H20.2404C17.1544 45.6386 15.2455 44.663 13.9305 43.804C13.6548 43.6237 13.3472 43.5389 13.0397 43.5389C12.6261 43.5389 12.2337 43.698 11.9262 44.0267C11.5338 44.3661 9.47643 45.2357 7.16457 45.2357C6.48586 45.2357 5.84957 45.1614 5.2663 45.013C8.0978 42.8602 8.46897 40.4953 8.56442 38.3637C8.57502 37.5896 8.56442 36.9533 8.55381 36.2109C8.54321 35.5852 8.5326 34.8747 8.5326 33.9203V25.2879C8.5326 18.8401 13.782 13.5907 20.2404 13.5907H42.7015ZM42.7015 12H20.2404C12.8912 12 6.94187 17.9493 6.94187 25.2985V33.9309C6.94187 35.9988 6.99489 36.9321 6.97368 38.3425C6.87824 40.4211 6.67675 42.8602 2 45.1296C3.53771 46.3916 5.40416 46.8264 7.16457 46.8264C9.97486 46.8264 12.52 45.7235 13.0609 45.1402C14.9273 46.3492 17.1013 47.2294 20.2404 47.2294H42.7121C50.0613 47.2294 56.0106 41.28 56.0106 33.9309V25.2985C56 17.9493 50.0507 12 42.7015 12Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9866 23.5275L47.2298 28.6815L39.976 33.8354",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.196 33.8354L16.9423 28.6815L24.2066 23.5275",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2282 20.1976C32.6375 25.7545 31.0361 31.3221 29.4454 36.879",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 35.2294,
    fill: "white",
    transform: "translate(2 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCcs);
export default __webpack_public_path__ + "static/media/iconCCS.924e7ff1.svg";
export { ForwardRef as ReactComponent };